import React from 'react';
import { useEffect, useState, useRef } from 'react';
import {} from 'react';
import { SIDEMENU_MODE } from '@maxis/client-logic/constants/enumerates';
// import styles from './SideMenu.module.css';
import styles from './_sideMenu.module.css';
import { useBoundStore } from '@maxis/client-logic/store/useBoundStore';
import { HOME_MENU_ID } from '@maxis/client-logic/constants/constMenuId';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { useLocation } from 'react-router-dom';

const SideMenuMainTab = ({ sideMenuMode, onMenuClick, showAllMenuInSide = false }) => {
    const { hierarchyMenu, selectedTopMenu, selectedMenu } = useBoundStore((state) => state.menu);
    const hierRef = useRef([]);
    const [menuItems, setMenuItems] = useState([]);
    const { pathname } = useLocation();

    const settingExpanded = (node) => {
        if (!node.children || node.children.length === 0) {
            return false;
        }

        for (let child of node.children) {
            // 현재 선택된 MENU ID 가 아니라면 children을 parameter로 줘서 재귀 돌림
            // 후에 선택된 MENU ID를 찾는다면 TRUE를 반환해서 해당 NODE 전체 expanded를 TRUE값을 줘서 SIDE MENU를 펼침
            if (child.menuId === selectedMenu.menuId || settingExpanded(child)) {
                node.expanded = true;
                return true;
            }
        }

        return false;
    };

    useEffect(() => {
        if (showAllMenuInSide) {
            if (!hierRef.current?.length) {
                hierRef.current = _.cloneDeep(hierarchyMenu);
            }

            if (selectedMenu?.menuId === HOME_MENU_ID) {
                // copyHierarchyMenu.forEach((node) => settingExpanded(node));
                // home일 경우 메뉴 전부 닫기 : hierarchyMenu는 초기값
                hierRef.current = _.cloneDeep(hierarchyMenu);
            } else {
                // 메뉴 선택 시, 해당 메뉴 열기 : sideMenu를 거치지 않고 호출되었을 경우 (url호출, tab 호출 등) 메뉴 대분류 중분류 소분류 열기
                hierRef.current.forEach((node) => settingExpanded(node));
            }

            setMenuItems(hierRef.current);
        } else {
            const children = hierarchyMenu?.find(
                (f) => f.menuId === selectedTopMenu?.menuId
            )?.children;
            const expandedList = children?.map((m) => ({
                ...m,
                ...(m.children?.length > 0 && { expanded: true }),
            }));
            setMenuItems(expandedList);
        }
    }, [hierarchyMenu, selectedTopMenu, showAllMenuInSide, selectedMenu]);

    const menuStyle = (e, lvl) => {
        let className = [];

        if (showAllMenuInSide) {
            className.push(styles.fromTopMenu);
        }
        if (lvl === 1) {
            className.push(styles.m01);
        } else if (lvl === 2) {
            className.push(styles.m02);
        } else if (lvl === 3) {
            className.push(styles.m03);
        } else if (lvl === 4) {
            className.push(styles.m04);
        } else if (lvl === 5) {
            className.push(styles.m05);
        }

        if (e.children?.length > 0) {
            if (!e.expanded) {
                className.push(styles.collapsed);
            } else {
                className.push(styles.expanded);
            }
        } else if (lvl === 1) {
            className.push(styles.nosubmenu);
        }
        if (selectedMenu.menuId === e.menuId) {
            className.push(styles.selected);
        }
        return className.join(' ');
    };

    const toggleExand = (menuId) => {
        setMenuItems((prev) => toggleExpand(menuId, prev));
    };

    const toggleExpand = (menuId, menuItems) => {
        return menuItems.map((menuItem) => {
            // If this menuItem's ID matches the target menuId, toggle its expanded state
            if (menuItem.menuId === menuId) {
                return {
                    ...menuItem,
                    expanded: !menuItem.expanded,
                    children: menuItem.children ? toggleExpand(menuId, menuItem.children) : [],
                };
            }

            // If the menuItem has children, recursively process them
            if (menuItem.children) {
                return {
                    ...menuItem,
                    children: toggleExpand(menuId, menuItem.children),
                };
            }

            // If no match and no children, return the menuItem unchanged
            return menuItem;
        });
    };

    const createMenuList = (childrenMenuList, lvl) => {
        if (!childrenMenuList || childrenMenuList.length === 0) {
            return;
        }

        return childrenMenuList
            ?.filter((f) => f.sideYn === 'Y' && f.displayYn === 'Y')
            .map((e) => {
                return (
                    <li
                        key={e.menuId}
                        // className={menuStyle(e, lvl)}
                        className={e.programRoutePath === pathname ? styles.on : null}
                        onClick={(event) => {
                            event.stopPropagation();
                            if (e.children?.length > 0) {
                                toggleExand(e.menuId);
                            } else {
                                onMenuClick(e);
                            }
                        }}
                    >
                        <span>{e.menuName}</span>
                        {e.expanded && e.children?.length > 0 && (
                            <>
                                <ul key={e.menuId}>{createMenuList(e.children, lvl + 1)}</ul>
                            </>
                        )}
                    </li>
                );
            });
    };
    return (
        <div
            className={styles.inner}
            style={{
                display: sideMenuMode === SIDEMENU_MODE.MENU ? 'block' : 'none',
            }}
        >
            {/* {console.log(menuItems)} */}
            {showAllMenuInSide ? null : <h2>{selectedTopMenu?.menuName}</h2>}
            {menuItems?.length > 0 ? (
                <ul>
                    {createMenuList(menuItems, showAllMenuInSide ? 1 : 2)}
                </ul>
            ) : null}
        </div>
    );
};

SideMenuMainTab.propTypes = {
    sideMenuMode: PropTypes.string,
    onMenuClick: PropTypes.func,
    showAllMenuInSide: PropTypes.bool,
};

SideMenuMainTab.displayName = 'SideMenuMainTab';
export default SideMenuMainTab;
